// This Privileges list created from the vault team Excel
export const PRIVILEGES = {
  VIEW_MESSAGING_AVAILABILITY_INFO: '1740',
  SKILL_CHATS: '9',
  VIEW_AGENT_LIST: '1574',
  VIEW_ALL_CHATS: '10',
  VIEW_MESSAGING_SURVEYS: '1754',
  VIEW_CAMPAIGN_MODULE: '1500',
  VIEW_USERS_MODULE: '1501',
  SET_MANUAL_SLA: '1741',
  SEND_FILES_FROM_CUSTOM_WIDGET: '1777',
  UPDATE_CONSUMER_PROFILE_VIA_API: '1750',
  VIEW_SECURE_FORMS: '1558',
  VIEW_HISTORY_SECURE_FORMS: '1571',
  GENERATE_SECURE_FORM_TOKEN: '1728',
  TRANSFER_TO_OFFLINE_AGENT: '1768',
  TRANSFER_TO_AWAY_AGENT: '1767',
  TRANSFER_TO_ONLINE_AND_BACK_SOON_AGENT: '1766',
  JOIN_CONVERSATION_PRIVILEGE: '13',
  HAS_AGENT_OR_AGENT_MANAGER_PROFILE: '1561',
  VIEW_AGENT_WORKSPACE: '1786',
  TAKEOVER: '1731',
  MESSAGING_HISTORY_PRIVILEGE: '1713',
  VIEW_ACTIVE_CONNECTIONS: '1734',
  ANSWERING_SERVICE_AGENT: '1764',
  SEND_FILES_FROM_LOCAL_SYSTEM: '1771',
  FAAS_INVOKE: '1772',
  VIEW_SMART_SUGGESTIONS: '1793',
  VIEW_AUTOCOMPLETE: '1794',
  VIEW_SMART_COMPOSE: '1860',
  PROVIDE_FEEDBACK_ON_SUGGESTION_OR_AUTOCOMPLETE: '1795',
  VIEW_AGENT_SURVEY: '1798',
  SUBMIT_AGENT_SURVEY: '1799',
  HANDLE_INTENT_ANNOTATIONS: '1852',
  VIEW_ALL_TASKS: '1853',
  HANDLE_FALSE_RESPONSES: '1868',
  RETURN_CONVERSATIONS_TO_THE_QUEUE: '1890',
  VIEW_SKILL_TRANSFER_EVENTS_IN_TRANSCRIPT: '1893',
  VIEW_AGENT_TRANSFER_EVENTS_IN_TRANSCRIPT: '1894',
  VIEW_BACK_TO_QUEUE_EVENTS_IN_TRANSCRIPT: '1895',
  VIEW_JOIN_EVENTS_IN_TRANSCRIPT: '1896',
  VIEW_TAKEOVER_EVENTS_IN_TRANSCRIPT: '1897',
  VIEW_AUTOMATED_CONVERSATION_SUMMARY: '1906',
  USE_SMART_REPLY: '1902',
  USE_SMART_COMPOSE: '1903',
  USE_SMART_REWRITE: '1905',
  VIEW_CONVERSATION_CLOSED_EVENTS_IN_TRANSCRIPT: '1907',
  VIEW_CONVERSATION_AUTO_UNASSIGNED_EVENTS_IN_TRANSCRIPT: '1908',
};

export const SESSION_SETTINGS = {
  AUTO_ACCEPT: 'messaging.routing.autoaccept',
  LANGUAGE: 'le.general.language',
  RECENTLY_CLOSED_CONVERSATIONS_DAYS: 'le.agent.recentlyClosedConversationDays',
  HOUR_FORMAT: 'le.agent.hourFormat',
  DISABLE_EMOJIS: 'le.agent.chatInput.disableIconsForMessaging',
  DISABLE_IFRAME_SANDBOX: 'disable.custom.widget.iframe.sandbox',
  DEFAULT_SUPPORTED_LANGUAGE: 'le.site.defaultSupportedLanguage',
  SUPPORTED_LANGUAGES: 'le.site.supportedLanguages',
  BLOCK_CONSUMER_NAME: 'le.agent.block.visitor.name',
  SUPPORT_UNAUTH_SDES: 'le.agent.messaging.sdes',
  SHOW_NEW_AGENT_WORKSPACE: 'le.agent.messaging.showEnhancedAgentWorkspace',
  ACD_MANUAL_SLA_AUTO_FOCUS_CONVERSATION: 'messaging.ACD.manual.autoFocusConversation',
  FILE_SHARING_BLUR_ALL_CONVERSATION_IMAGES: 'messaging.file.sharing.blurAllConversationImages',
  BLUR_CONSUMER_THUMBNAILS_FROM_BACKEND_ENABLED: 'messaging.file.sharing.blurThumbnails',
  FILE_SHARING_IMAGE_PREVIEW_SIZE: 'messaging.agent.photo.size',
  FILE_SHARING_IS_ENABLED_FOR_AGENT: 'messaging.agent.file.sharing.enabled',
  FILE_SHARING_IS_ENABLED: 'messaging.file.sharing.enabled',
  AUDIO_SHARING_IS_ENABLED: 'messaging.audio.sharing.enabled',
  NEW_AGENT_WORKSPACE_LPA: 'le.agent.messaging.newAgentWorkspaceForLPA',
  ALLOW_MICROPHONE_CAMERA: 'le.agent.widgetSdk.allowMicrophoneCamera',
  PREDEFINED_CONTENT_SHOW_TITLE_ONLY: 'le.agent.messaging.pdc.show.title.only',
  SHOW_AUTH_INDICATOR_FOR_CONNECTOR: 'le.newAgentWorkspace.showAuthIndicatorForConnectors',
  IDLE_TIME: 'le.agent.messaging.conversationIdleTime.minutes',
  SMART_SUGGESTIONS_SETTINGS: 'le.suggestions',
  ACCOUNT_INFO: 'le.site.accountInfo',
  SMART_CAPACITY_DEFAULT: 'messaging.smart.capacity.fresh.agent.pending.time.sec',
  SMART_CAPACITY_PER_SKILL: 'messaging.smart.capacity.per.skill.definition',
  DEACTIVATE_SHORTCUTS: 'le.general.deactivateShortcuts',
  SHOW_CONVERSATION_SOURCE_IN_LIST: 'le.newAgentWorkspace.showConversationSourceInList',
  ALERT_ON_PASTE: 'le.agent.alertOnPaste',
  DISABLED_NON_RESPONSE_STATE: 'messaging.connection.nonresponsivestate.disabled',
  CUSTOM_RINGS_ENABLED: 'le.ui.custom.rings.enabled',
  HIDE_HISTORY_CONVERSATIONS_IN_TRANSCRIPT_FOR_SKILLS: 'messaging.hide.history.conversations.in.transcript.for.skills',
  SAME_SKILL_TRANSFER_PREVENTION: 'messaging.transferBySkill.preventTransferToSameSkill',
  SHOW_READ_INDICATION_BELOW_MESSAGE: 'le.agent.messaging.show.read.indication.below.message',
  AGENT_NOT_TYPING_TIMEOUT: 'le.site.messaging.agentNotTypingTimeout',
  CUSTOM_WIDGET_SEND_ERROR_ON_GET_NULL_SUB_KEY: 'le.agent.widgetSdk.sendErrorOnGetSubKeyOfNull',
  SOCIAL_MESSAGING_FACEBOOK_ENABLED: 'socialmessaging.ui.datasource.enabled',
  MASKED_RECENTLY_CLOSED_CONVERSATION_TRANSCRIPT_MINUTES: 'le.agent.maskedRecentlyClosedConversationTranscriptMinutes',
  MASKED_RECENTLY_CLOSED_CONVERSATION_TRANSCRIPT: 'le.agent.fetchRecentlyClosedMaskedConversationTranscript',
  FETCH_ONGOING_CONVERSATION_INTERVAL: 'le.ui.fetchOngoingConversationDataInterval',
  FETCH_CLOSED_CONVERSATION_INTERVAL: 'le.ui.fetchClosedConversationDataInterval',
  NEUTRAL_COUNTRY_LABEL: 'le.site.neutralCountryLabel',
  PERFORMANCE_LOG_INTERVAL: 'le.site.performanceLogInterval.minutes',
  PHASE: 'le.site.leui.phase',
  GET_CUSTOM_WIDGET_TIMEOUT: 'le.ui.customWidgetsTimeoutSeconds',
  DISPLAY_SECURE_FORMS_SENT_BY_BOTS: 'messaging.display.secure.form.sent.by.bots',
  ADD_REPLACE_SMART_REPLY_CONTROLS: 'le.suggestions.smartReply.addReplaceSmartReplyControls',
  USERS_THAT_NEEDS_ACCESSIBILITY: 'le.ui.a11y.usersWithFocusOutline',
  STEP_UP_NOTIFICATION: 'messaging.stepUpNotifications',
  FILTER_SECURE_FORM: 'messaging.FilterSecureForms',
  SHOW_JOURNEY_WIDGET: 'messaging.journey.widget',
  ALLOW_SENDING_BOT_MESSAGES_TO_SMART_ASSIST: 'le.suggestions.allowSendingBotMessagesToSmartAssist',
  SHOW_WHATSAPP_MTM_ALERT_IN_CONVERSATION_TRANSCRIPT: 'le.agent.messaging.showWhatsappMtmAlertInConversationTranscript',
  HIDE_SLA_TIMER_SKILL_LIST: 'messaging.hideSLATimerSkillList',
  CUSTOM_WIDGET_ALLOW_COPY: 'le.ui.customWidgets.allowCopy',
  LP_LLM_AGREEMENT_INFO: 'lp.llm.agreementInfo',
  ROLLOVER_CONFIG: 'messaging.brand.rollover.config',
  MESSAGING_SORT_SECURE_FORM: 'messaging.sort.secure.forms',
  INSTAGRAM_WIDGET_STATUS: 'socialmessaging.connectors.instagram.widget.enabled',
  LEGACY_AGENT_STATE: 'common.legacyAgentState',
  BOT_MUTE_NOTIFICATION: 'messaging.bot.mute.notification',
  TWITTER_CONNECTOR: 'social.settings.twitter',
  FACEBOOK_CONNECTOR: 'social.settings.facebook',
  INSTAGRAM_CONNECTOR: 'social.settings.instagram',
  CONVERSATION_TIMERS_COLLAPSED: 'messaging.conversation.timers.collapsed',
  SMART_REWRITE_SUPPORTED_ACTIONS: 'smartRewrite.supportedActions',
  FAVORITE_PREDEFINED_CONTENT: 'messaging.favoritePredefinedContent_',
  MESSAGES_LAZY_PAGE_SIZE: 'messaging.conversation.lazyPageSize',
  FAVORITES_LIMIT_PER_USER: 'messaging.pdc.favoritesLimitPerUser',
  MAX_CUSTOM_PREDEFINED_CONTENT: 'messaging.customPredefinedContent.max.allowed.number',
};

export const FEATURES = {
  ASYNC_MESSAGING: 'Common.Async_Messaging',
  AGENT_WORKSPACE_FEATURE: 'Messaging.New_agent_workspace',
  ENFORCE_NEW_AGENT_WORKSPACE: 'LEUI.Enforce_New_Agent_Workspace',
  BLOCK_NEW_AGENT_WORKSPACE: 'LEUI.Block_New_Agent_Workspace',
  VIEW_MESSAGING_SECURE_FORM: 'LEUI.Messaging_Secure_Form',
  VIEW_SECURE_FORM_HISTORY: 'Reports.EngagementHistory_PCI_Data_Display',
  GENERATE_SECURE_FORM_TOKEN: 'Reports.GenerateSecureFormToken',
  TRANSFER_TO_AGENT: 'Messaging.Transfer_To_Agent',
  TAKEOVER: 'Common.Takeover_Conversation',
  MESSAGING_SURVEY: 'Common.Messaging_Survey',
  AGENT_GROUPS: 'Common.AgentGroups',
  CAN_SHARE_ADDITIONAL_FILE_TYPES: 'Messaging.Agent_File_Sharing_v2',
  FAAS: 'FaaS.FaaS',
  CONTACT_CENTER: 'Common.Messaging_Cross_Account_Contact_Center',
  ANSWERING_SERVICE: 'Common.Answering_Service',
  AGENT_SET_CONSUMER_PROFILE: 'Messaging.AgentSetConsumerProfile',
  SOCIAL_CONNECT: 'SocialConnect.Enabled',
  CAN_USE_SMART_SUGGESTIONS: 'Messaging.Smart_Suggestions',
  CAN_SEND_HYPERLINKS: 'Messaging.Agent_Link_Sending',
  CONVERSATION_SUMMARY_WIDGET: 'Messaging.Conversation_Summary_Widget',
  AGENT_SURVEY: 'Messaging.Agent_Survey',
  RICH_CONTENT: 'Common.RichContent',
  SEND_PRIVATE_MESSAGE: 'Messaging.Private_Messages',
  // When this feature is on, there is no need to update agent status in UMS
  PREVENT_UPDATE_AGENT_STATUS_AT_UMS: 'Messaging.Set_Agent_State_By_Facts',
  AUTHENTICATED_CHAT: 'Common.Authenticated_Chat',
  HANDLE_INTENT_ANNOTATIONS: 'Tasks.Handle_Intent_Annotaitons',
  HANDLE_FALSE_RESPONSES: 'Tasks.Handle_False_Responses',
  USE_CUSTOM_RINGS: 'LEUI.Use_Custom_Rings',
  BAM_ENABLED: 'LEUI.BAM_Enabled',
  AHT_ENABLED: 'Common.WorkforceManagement_AHT',
  AI_ASSIST_WIDGET: 'Common.AI_Assist_Widget',
  RICH_TEXT_FORMATTING: 'Messaging.Rich_Text_Formatting',
  SEND_CONSUMER_MESSAGE_METADATA: 'Messaging.Send_Consumer_Message_Metadata',
  IS_CTRL_ENTER_FEATURE_ENABLED: 'Messaging.isCtrlEnterFeatureEnabled',
  CONSUMER_MESSAGE_CHANNEL_INDICATOR: 'Messaging.Consumer_Message_Channel_Indicator',
  ALLOW_LINK_RENDERING: 'Messaging.AllowLinksRendering',
  WIDGET_TWITTER_ENABLED: 'SocialMessaging.Widget_Twitter_Enabled',
  WIDGET_FACEBOOK_ENABLED: 'SocialMessaging.Widget_Facebook_Enabled',
  MODERATION_ENABLED: 'SocialMessaging.Moderation_Enabled',
  AGENT_MODERATION_ENABLED: 'SocialMessaging.Agent_Message_Delete_Enabled',
  CONTROL_RETURN_TO_QUEUE: 'Common.ControlReturnToQueue',
  SHOW_CONVERSATION_EVENTS_IN_TRANSCRIPT: 'Messaging.Conversation_Events_In_Transcript',
  DISPLAY_MCS_IN_CONVERSATION: 'Messaging.Display_MCS_In_Conversation',
  AUTOMATED_CONVERSATION_SUMMARY: 'Messaging.Automated_Conversation_Summary',
  AI_AUTOMATION_GENERATIVE_AI_PREVIEW: 'AIAutomation.GenerativeAI_Preview',
  AI_AUTOMATION_GENERATIVE_AI: 'AIAutomation.GenerativeAI',
  ENHANCED_STATUS_FILTER: 'messaging.enhanced_status_filter',
  ENHANCED_STATUS_FILTER_UPPER: 'Messaging.enhanced_status_filter',
  HIDE_SLA_TIMER_PER_SKILL: 'Messaging.hideSLATimerPerSkill',
  SMART_REPLY: 'Messaging.Smart_Reply',
  SMART_COMPOSE: 'Messaging.Smart_Compose',
  CONNECTORS_AUDIO_SHARING: 'Messaging.Connectors_Audio_Sharing',
  IS_CHAT_ENABLE: 'Common.Legacy_Chat',
  CONVERSATION_TIMERS: 'Messaging.Conversation_Timers',
  SMART_REWRITE: 'Messaging.Smart_Rewrite',
  SELECT_FAVORITE_PREDEFINED_CONTENT: 'Messaging.Select_Favorite_Predefined_Content',
  LAST_MESSAGE_TOOLTIP: 'Messaging.HideLastMessageTooltip',
  CUSTOM_PREDEFINED_CONTENT_FEATURE: 'Messaging.Agent.CustomPdc',
};

export const FEATURE_FLAGS = {
  SHOW_INLINE_RECOMMENDED_ACTIONS: { name: 'showInlineRecommendedActions', default: true },
  SHOW_AGENT_SURVEY: { name: 'showAgentSurvey', default: true },
  SEPARATED_OPEN_CLOSED_SUBSCRIPTIONS: { name: 'separatedOpenClosedSubscriptions', default: true },
  HAS_MESSAGING_LAZY_LOAD_MESSAGES: { name: 'hasMessagingLazyLoadMessages', default: false },
  TOGGLE_TWITTER_CHARACTER_LIMIT: { name: 'toggleTwitterCharacterLimit', default: false },
  SEARCH_BY_CONSUMER_INITIAL_RETRY_DELAY: { name: 'searchByConsumerInitialRetryDelay', default: 15 },
  STOP_AC_CAMPAIGNS_RETRY_MECHANISM: { name: 'stopAcCampaignsRetryMechanism', default: false },
  HAS_VISITOR_NAME_FILTER: { name: 'hasVisitorNameFilter', default: false },
  SHOULD_DISPLAY_SECURE_FORMS_SENT_BY_BOTS: { name: 'shouldDisplaySecureFormsSentByBots', default: true },
  SHOW_ADD_REPLACE_SMART_REPLY_CONTROLS: { name: 'showAddReplaceSmartReplyControls', default: true },
  RENDER_LINK_IN_WORKSPACE: { name: 'RenderLinksInTheWorkspace', default: false },
  SOCIAL_TWITTER_FACEBOOK_WIDGET_ENABLED: { name: 'socialTwitterFacebookWidgetEnabled', default: false },
  SORT_SECURE_FORM: { name: 'SortSecureForm', default: false },
  SORT_PAGE_NAVIGATION: { name: 'SortPageNavigation', default: false },
  USE_NEW_API_TO_FILTER_SECURE_FORMS: { name: 'UseNewAPItoFilterSecureForms', default: false },
  ENABLE_WHATSAPP_PRODUCT_MESSAGE: { name: 'enableWhatsappProductMessage', default: false },
  SHOW_CONVERSATION_EVENTS_IN_TRANSCRIPT: { name: 'showConversationEventsInTranscript', default: true },
  SHOW_ABC_FORM_MESSAGE: { name: 'showAbcFormMessage', default: false },
  ENABLE_FACEBOOK_DELETE_MODERATION: { name: 'enableFacebookDeleteModeration', default: false },
  ENABLE_FACEBOOK_AGENT_DELETE_MODERATION: { name: 'enableFacebookAgentDeleteAgentMessage', default: false },
  ENABLE_INSTAGRAM_AGENT_DELETE_MODERATION: { name: 'enableInstagramAgentDeleteAgentMessage', default: false },
  ENABLE_TWITTER_AGENT_DELETE_MODERATION: { name: 'enableTwitterAgentDeleteAgentMessage', default: false },
  ENABLE_FACEBOOK_HIDE_UNHIDE_MODERATION: { name: 'enableFacebookHideUnhideModeration', default: false },
  ENABLE_INSTAGRAM_DELETE_MODERATION: { name: 'enableInstagramDeleteModeration', default: false },
  ENABLE_INSTAGRAM_HIDE_UNHIDE_MODERATION: { name: 'enableInstagramHideUnhideModeration', default: false },
  SMART_COMPOSE_SELECTED_KEY_FEEDBACK: { name: 'SmartComposeSelectedKeyFeedback', default: false },
  SHOW_SECURE_FORM_SUBMISSION_IFRAME: { name: 'showSecureFormSubmissionIFrame', default: true },
  AGENT_SMART_ASSIST_V2: { name: 'AgentSmartAssistV2', default: false },
  ENABLE_FETCH_PAST_TWILIO_CONV_AFTER_TELNYX_MIGRATION: { name: 'enableFetchPastTwilioConvAfterTelnyxMigration', default: true },
  ENHANCED_STATUS_FILTER: { name: 'enhancedStatusFilter', default: false },
  DISPLAY_CONVERSATION_AUTOMATED_SUMMARY: { name: 'DisplayConversationAutomatedSummary', default: false },
  ENABLE_AUTOMATED_SUMMARY_DISPLAY_ON_AGENT_LEVEL_PERMISSION: { name: 'enableAutomatedSummaryDisplayOnAgentLevelPermission', default: false },
  ENABLE_NEW_WHATSAPP_REPLY_MESSAGE_COMPONENT: { name: 'enableNewWhatsappReplyMessageComponent', default: false },
  ENABLE_NACK_ERROR_MESSAGE: { name: 'enableNackErrorMessage', default: false },
  ENABLE_STRUCTURED_CONTENT_RECOMMENDATIONS: { name: 'enableStructuredContentRecommendations', default: false },
  ALLOW_HIDE_SLA_TIMER: { name: 'AllowHideSLATimer', default: true },
  ENABLE_FACEBOOK_LIKE_CONSUMER_MESSAGE: { name: 'enableFacebookLikeConsumerMessage', default: false },
  ENABLE_TWITTER_LIKE_CONSUMER_MESSAGE: { name: 'enableTwitterLikeConsumerMessage', default: false },
  ENABLE_LLM_RECOMMENDATIONS: { name: 'enableLLMRecommendations', default: false },
  ENABLE_LLM_RECOMMENDATIONS_FOR_LATEST_MESSAGE_ONLY: { name: 'enableLLMRecommendationsForLatestMessageOnly', default: false },
  ENABLE_THUMBS_RECOMMENDATIONS_FEEDBACK: { name: 'enableThumbsRecommendationFeedback', default: false },
  IS_DECODE_SECURE_FORM_TITLE: { name: 'isDecodeSecureFromTitle', default: false },
  HIDE_ISP: { name: 'hideISP', default: true },
  RESUME_COBROWSE_ON_TAB_RELOAD: { name: 'resumeCobrowseOnTabReload', default: false },
  IS_USED_PCI_COMPLIANCE_SERVICE: { name: 'IsUsedPciComplianceService', default: false },
  AGENT_AUDIO_SHARING: { name: 'AgentAudioSharing', default: false },
  USE_AGENT_STATE_DECOUPLE_FROM_DENVER: { name: 'useAgentStateDecoupleFromDenver', default: false },
  TIME_OUT_FOR_BLENDED_ACCOUNT: { name: 'timeoutForBlendedAccount', default: 10000 },
  ENABLED_TWITTER_SITE_SETTINGS: { name: 'enableTwitterSiteSettings', default: false },
  ENABLED_FACEBOOK_SITE_SETTINGS: { name: 'enableFacebookSiteSettings', default: false },
  ENABLED_INSTAGRAM_SITE_SETTINGS: { name: 'enableInstagramSiteSettings', default: false },
  ENABLE_BOT_IN_PARTICULAR_CONVERSATION: { name: 'enableBotInParticularConversation', default: false },
  SHOW_PARTICIPANT_BOT_NAME_IN_CONVERSATION_BANNER: { name: 'showParticipantBotNameInConversationBanner', default: false },
  ENABLE_HALLUCINATED_RECOMMENDATIONS: { name: 'enableHallucinatedRecommendations', default: false },
  DISPLAY_CONVERSATION_TIMERS: { name: 'displayConversationTimers', default: false },
  IS_ENTER_BEARER_TOKEN_TO_WS: { name: 'isEnterBearerTokenToWS', default: false },
  ENABLE_RECOMMENDATION_TITLE_BASE_ON_LLM_RESPONSE: { name: 'enableRecommnendationBasedOnLLMResponse', default: false },
  USE_SMART_REWRITE: { name: 'useSmartRewrite', default: false },
  DISPLAY_FAVORITE_PREDEFINED_CONTENT: { name: 'displayFavoritePredefinedContent', default: false },
  DISPLAY_CUSTOM_PREDEFINED_CONTENT: { name: 'displayCustomPredefinedContent', default: false },
  ALLOW_TXT_AND_CSV_FILE_TYPES: { name: 'allowTxtCsvFileTypes', default: false },
  USE_NEW_AGENT_LIST_API_FOR_TRANSFER: { name: 'useNewAgentListApiForTransfer', default: false },
  ENABLE_RECOMMENDATIONS_FOR_CLOSED_CONVERSATION: { name: 'enableRecommendationsForClosedConversation', default: false },
  LOG_FEEDBACK_SMART_REWRITE: { name: 'logFeedbackSmartRewrite', default: false },
  USE_ROLLOVER_CONVERSATION_HANDLER_SKILL_ID: { name: 'useRolloverConversationHandlerSkillId', default: false },
  ENABLE_AMB_RSA_TOGGLE: { name: 'enableAmbRsaToggle', default: false },
  DISPLAY_IDAVID_SECURE_FORMS: { name: 'displayIdavidSecureForms', default: false },
  ENABLE_RECOMMENDATION_ANALYTICS_EVENTS_V2: { name: 'enableRecomendationAnalyticsEventsV2', default: false },
  ENABLE_RULES_BASED_RECOMMENDATIONS: { name: 'enableRulesBasedRecommendations', default: false },
  ENABLE_CHANGE_STATUS_AUTO_BY_AGENT_MATCHING: { name: 'enableChangeStatusAutoByAM', default: false },
  USE_GENERIC_TPC_POST_MENU: { name: 'useGenericTpcPostMenu', default: false },
  USE_GENERIC_TPC_PARENT_POST_IN_WA: { name: 'useGenericTpcParentPostInWA', default: false },
  USE_GENERIC_TPC_PARENT_POST_IN_SOCIAL: { name: 'useGenericTpcParentPostInSocial', default: false },
  ENABLE_NEW_TWITTER_ENDPOINT: {name: 'enableNewTwitterEndpoint', default: false},
  SHOW_SMART_REWRITE_MESSAGE_INDICATION: { name: 'showSmartRewriteMessageIndication', default: false},
};

export const LAUNCH_DARKLY_ENVIRONMENTS = {
  LD_CLIENT_SITE_ID: 'ldClientSideId',
};

export const FRONTIER_FEATURES = {
  AVAILABLE_CONNECTORS_AUDIO_SHARING: 'availableConnectorsAudioSharing',
};

export const ACCOUNT_VERTICAL = {
  AUTOMOTIVE: 'automotive',
};

export const AUTOCOMPLETE_MODES = {
  SINGLE: 'single',
  MULTI: 'multi',
  BOTH: 'both',
};

export const ROLE_TYPES = {
  1: 'Administrator',
  2: 'Agent',
  3: 'Agent Manager',
  4: 'Campaign Manager',
};
